<template>
  <div>
    <v-layout wrap pt-5 justify-center>
      <v-flex xs11 text-left>
        <span
          style="color: #1f1f1f; font-family: poppinssemibold; font-size: 20px"
          >Cancellation Policy</span
        >
      </v-flex>
      <v-flex xs12 sm11 md11 lg11 xl11 pt-5 pb-16 text-justify>
        <span
          style="font-family: poppinsregular; font-size: 15px; color: #1a1919"
        >
          <!-- v-html="pageData.details" -->
          <b>1. Order Cancellation </b> <br>  <br> You may cancel your order within 24 hours of
          placing it for a full refund. To cancel your order, please contact our
          customer service at [insert contact information] with your order
          number and request for cancellation.
          <br> <br> <b>2. Non-Refundable Items Certain</b>
          <br> <br> 
          items may be marked as non-refundable. Please check the product
          description or contact us if you are unsure.
          <br>  <br>  <b>3. Cancellation After 24</b> <br> <br>  
          Hours If you wish to cancel your order after 24 hours, a cancellation
          fee of 10% of the total order value may apply. To proceed with the
          cancellation, please contact us, and we will guide you through the
          process. <br> <br>  
           <b>4. Refund Process</b>
           <br>   <br>   Refunds will be processed within 7-10
          business days after the cancellation is confirmed. Refunds will be
          issued to the original payment method used at the time of purchase. <br> 5.
          Exchange Policy If you wish to exchange a product, please refer to our
          exchange policy [link to exchange policy if available].
        </span>
      </v-flex>
    </v-layout>
  </div>
</template>
    <script>
import axios from "axios";
export default {
  data() {
    return {
      pageData: {},
    };
  },
  beforeMount() {
    // this.getData();
  },
  methods: {
    getData() {
      axios({
        method: "GET",
        url: "/cancellationPolicy",
        // params: {
        //   Name: "Terms and Conditions",
        // },
      })
        .then((response) => {
          this.pageData = response.data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>